import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from 'axios'

const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}

export const SaveAnswer = createAsyncThunk('questions/saveAnswer', async (incomingVariable, thunkAPI) => {
    try {
     //const response = await fetch("/api/surveys/set",{method:"POST", body:JSON.stringify(incomingVariable)})
     //const data = await response.json()
     //// insert error handling success=false
     //return data

     const response = await axios.post('../../WsWebServiceHra/SaveAnswer/' + incomingVariable.auth + '/' + incomingVariable.response + '/' + incomingVariable.questionID + '/' + incomingVariable.value + '/')
     const data = await response.data
     return data

       // return Save(...incomingVariable)
    } catch (err) {
      console.log('error', err)
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  })


const questionSlice = createSlice({
    name: 'questions',
    initialState,
    reducers: {
        questionAdd(state, action) {
            const questionData = action.payload
            state.entities[questionData.QuestionId] = questionData
        },
        questionModify(state, action) {
            const questionData = action.payload
            state.entities[questionData.QuestionId] = questionData
        } ,
        
        questionBranchingLogicModify(state, action) {
            const questionData = action.payload
            const currentquestion = state.entities[questionData.QuestionId]
            state.entities[questionData.QuestionId] = {
                ...currentquestion
                    , QuestionDisplayedFlag: questionData.QuestionDisplayedFlag
                    , QuestionRequiredFlag:questionData.QuestionRequiredFlag
                }
        },
        questionDelete(state, action) {
            const questionData = action.payload
            delete state.entities[questionData.QuestionId]
        },
        questionHydrate(state, action) {
            const questionData = action.payload
            state.entities=questionData
            state.status = 'success'
        },
        questionSaveModify(state, action){
            const questionData = action.payload
            const currentQuestion = state.entities[questionData.QuestionId]
            state.entities[questionData.QuestionId] = {
                ...currentQuestion,
                Responses: [{
                    Response: questionData.value}]
            }
        }
        
    },
    extraReducers(builder) {
        builder
            .addCase(SaveAnswer.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(SaveAnswer.fulfilled, (state, action) => {
                const loadedData = action.payload.Info
                const data = state.entities
                if(loadedData.length){
                   for (var i=0; i<loadedData[0].Changes.length; i++){
                    data[loadedData[0].Changes[i].QuestionId] = {...data[loadedData[0].Changes[i].QuestionId],
                                                                QuestionDisplayedFlag: loadedData[0].Changes[i].DisplayFlag,
                                                                QuestionRequiredFlag: loadedData[0].Changes[i].RequiredFlag}
                   }
                }
                state.entities = data
                state.status = 'success'
            })
    }
}) 

export const { questionAdd, questionModify, questionDelete, questionHydrate, questionBranchingLogicModify, questionSaveModify } = questionSlice.actions

export default questionSlice.reducer

const selectQuestionEntities = (state) => state.questions.entities

export const selectQuestions = createSelector(selectQuestionEntities, (entities) =>
    Object.values(entities)
)

export const selectQuestionById = (state, QuestionId) => {
    return selectQuestionEntities(state)[QuestionId]
}

export const selectQuestionsInQuestionSet = createSelector(
    selectQuestions
    , (state, QuestionSetId) => QuestionSetId
    , (questions, QuestionSetId) => {

        return questions.filter((question) => {
            return question.QuestionSetId === QuestionSetId
        })
    }

)

export const selectNextVisibleQuestion = createSelector(
    selectQuestions
    , (state, QuestionId) => QuestionId
    , (questions, QuestionId) => {
        
        for(let i=questions.findIndex(question => question.QuestionId == QuestionId)+1; i<questions.length; i++){
            if(questions[i].QuestionDisplayedFlag === "1"){
                return questions[i]
            }
        }
        return null
    }

)

export const FilteredQuestions = createSelector(
    selectQuestions
    , (state, filter) => filter
    , (questions, filter) => {
        return questions.filter((question) => {
            return question[filter] === "1"
        })
    }
)

export const AnsweredQuestions = createSelector(
    selectQuestions
    , (questions) => {
        return questions.filter((question) => {
            return question.Responses[0].Response.length && question.Responses[0].Responses != '-1'
        })
    }
)
